import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { BulkSchedulingStateService } from 'app/main/plus/calendar/bulk-scheduling.state.service';
import { effect } from '@angular/core';
import { EventFlowService } from 'app/main/plus/calendar/event-flow.service';

@Component({
  selector: 'app-on-going-event',
  imports: [
    MatChipsModule,
    MatMenuModule,
    CommonModule,
    MatIconModule
  ],
  templateUrl: './on-going-event.component.html',
  styleUrl: './on-going-event.component.scss'
})
export class OnGoingEventComponent {

  @Input() currentEvents: any[] = [];
  showParticipantList: boolean = false;
  isBulkModeActive: boolean = false;

  constructor(private bulkSchedulingStateService: BulkSchedulingStateService,private eventFlowService: EventFlowService,) {
    setTimeout(() => {
      console.log('currentEvents=====>' , this.currentEvents );
      // 93 096 747
    }, 1000)
    
    effect(() => {
      this.isBulkModeActive = this.bulkSchedulingStateService.isActive();
    });
  }

  get hasMultipleParticipants(): boolean {
    return this.currentEvents.length > 1;
  }

  toggleParticipantList(): void {
    if (this.hasMultipleParticipants) {
      this.showParticipantList = !this.showParticipantList;
    }
  }

  closeParticipantList(): void {
    this.showParticipantList = false;
  }

  get showChip(): boolean {
    return this.currentEvents && this.currentEvents.length > 0;
  }

  get chipLabel(): string {
    if (this.currentEvents.length === 1) {
      return this.currentEvents[0].candidateName;
    }
    return `+${this.currentEvents.length}`;
  }
  private getEventCategory(event: any): string | null {
  if (event.type === 'busy') return 'busy';
  if (event.type?.startsWith('code')) return 'code';
  if (event.type?.startsWith('conduite')) return 'conduite';
  return null;
}
openEventDialog(event: any): void {
  const category = this.getEventCategory(event);

  if (!event?.id || !category) {
    return;
  }

  this.showParticipantList = false;
  this.eventFlowService.editEvent(event.id, category, true, false);
}
handleOngoingEventClick(): void {
  if (this.hasMultipleParticipants) {
    this.toggleParticipantList();
    return;
  }

  this.openEventDialog(this.currentEvents[0]);
}
}
